Alpine.store("mapState", {
    isActive: false,
    toggle() {
        this.isActive = !this.isActive;
    },
    init() {
        const mapQuery = window.location.search.substring(1);
        if (mapQuery) {
            this.isActive = true;
        }
    }
})

export const initProjectsTabs = () => {




    window.projectCategoryNav = () => {
        return {
            activeTab: 'Alle', // Default active tab

            init() {
                // Check if a hash exists in URL, then update the active tab accordingly
                const urlHash = window.location.hash.substring(1);
                const mapQuery = window.location.search.substring(1);
                if (mapQuery) {
                    this.map = true;
                }

                if (urlHash) {
                    this.activeTab = this.capitalizeFirstLetter(urlHash);
                    setTimeout(() => {
                        this.sendEvent();
                    }, 0)

                } else {
                    setTimeout(() => {
                        this.sendEvent();
                    }, 0)
                }


            },

            selectTab(tab) {
                if (this.activeTab === tab) return;
                this.activeTab = tab;
                window.location.hash = `#${tab.toLowerCase()}`;
                this.sendEvent();
            },

            isActive(tab) {
                return this.activeTab === tab;
            },


            sendEvent() {
                //console.log(this.activeTab, 1)
                this.$dispatch('tabschanged', {selectedTab: this.activeTab}, true);
            },

            capitalizeFirstLetter(string) {
                return string.charAt(0).toUpperCase() + string.slice(1);
            }
        }
    }


}